import ScrollUp from 'react-scrollup-lite';
import { ScrollUpProps } from 'react-scrollup-lite';
import { styled } from '@mui/system';

interface StyledScrollUpProps extends ScrollUpProps {
  children?: any;
}

export const StyledScrollUp = styled(ScrollUp)<StyledScrollUpProps>({});
